export default {
  name: 'localeMixin',
  data () {
    return {
      params: {
        code: this.$route.params.code,
        locale: this.$route.params.locale
      }
    }
  },
  computed: {
    defaultRoute () {
      switch (true) {
        case this.$store.viewed[0] === 'signIn':
          return '/homehub/login'
        case this.$store.viewed[0] === 'askForEmail':
          return '/homehub/onboarding/ask-for-email'
        case this.$store.viewed[0] === 'registerAccount':
          return '/homehub/onboarding/register-account'
        case this.$store.viewed[0] === 'loNotFound':
          return '/homehub/lo_not_found'
        default:
          return '/homehub/signup'
      }
    },
    codePath () {
      return this.params.code ? `/${this.params.code}` : ''
    }
  },
  methods: {
    switchLocale (locale) {
      if (locale) {
        this.params.locale = locale
      } else {
        this.params.locale === 'en' || this.params.locale === undefined ? this.params.locale = 'es' : this.params.locale = 'en'
      }
      window.location.href = `/${this.params.locale}${this.defaultRoute}${this.codePath}${window.location.search}`
    }
  }
}
